// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1cmA3","actions":"GroupTable_actions__W9wg1","deleteModalFooter":"GroupTable_deleteModalFooter__32WuJ"};